import { cn } from '../../../../lib/utils';
import { Checkbox } from '../../../../ui/checkbox';
import type { BaseFieldProps, CheckboxFieldSchema } from '../../../types';

export function CheckboxFieldInput({
  field,
  value,
  onChange,
}: BaseFieldProps<CheckboxFieldSchema, boolean | null | undefined>) {
  return (
    <div className="flex items-center gap-2 pt-1">
      <Checkbox
        id={field.id}
        checked={!!value}
        onCheckedChange={(checked) => onChange?.(checked === 'indeterminate' ? false : checked)}
      />
      <label
        htmlFor={field.id}
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {field.label}
      </label>
    </div>
  );
}

export function CheckboxFieldView({
  value,
}: BaseFieldProps<CheckboxFieldSchema, boolean | null | undefined>) {
  return (
    <div className="flex items-center gap-2">
      <div
        className={cn(
          'w-4 h-4 rounded border flex items-center justify-center',
          value ? 'bg-primary border-primary text-primary-foreground' : 'border-muted-foreground'
        )}
      >
        {value && (
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
      <span className="text-sm">{value ? 'Yes' : 'No'}</span>
    </div>
  );
}
